import { inject, InjectionToken, Provider } from '@angular/core';
import { StudyListFacadeService } from '@data-access/shared/facades/study-list.facade.service';
import { ORGANIZATION_STUDY_LIST_SIGNAL_STORE } from '../signal-store/study-list.signal.store';
import { StudyListSignalState } from '../../types';

export const STUDY_LIST_TOKEN = new InjectionToken<StudyListSignalState>(
  'Organization Study List',
);

export const STUDY_LIST_PROVIDER: Provider = {
  provide: STUDY_LIST_TOKEN,
  useClass: ORGANIZATION_STUDY_LIST_SIGNAL_STORE,
};

export const STUDY_LIST_SERVICE = new InjectionToken<StudyListFacadeService>(
  'OrganizationStudyListFacadeService',
);

export function organizationStudyListTokenizer() {
  return inject(STUDY_LIST_TOKEN);
}
